module.exports = __webpack_public_path__ + "img/banner_left.c67b6e8b.png";